// Инициализация кнопок действия

import Lightbox from '../../../elements/Lightbox';
import getDetailsContent from '../../../utils/getDetailsContent';

/**
 * Инициализация кнопок действия
 */
function main(): void
{
	const detailsElements = document.querySelectorAll(
		'main details',
	) as NodeListOf<HTMLElement>;
	
	for ( let i = 0, n = detailsElements.length; i < n; i++ )
	{
		initDetailsElement( detailsElements[i] );
	}

	const promotionElement = document.querySelector( 'main div.view div.promotion' ) as HTMLElement;

	if ( promotionElement )
	{
		initPromotion( promotionElement, detailsElements[0] );
	}
}

/**
 * Инициализация открытия блоков подробностей
 */
function initDetailsElement( details: HTMLElement ): void
{
	const lightboxContent: Node[] = getDetailsContent( details );
	const lightbox = Lightbox.instance;
	
	details.addEventListener(
		'click',
		( event: Event ): void =>
		{
			event.preventDefault();
			lightbox.open( lightboxContent );
		},
	);
}

function initPromotion( promotion: HTMLElement, details: HTMLElement ): void
{
	const lightboxContent: Node[] = getDetailsContent( details );
	const lightbox = Lightbox.instance;
	
	promotion.addEventListener(
		'click',
		( event: Event ): void =>
		{
			event.preventDefault();
			lightbox.open( lightboxContent );
		},
	);
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/Card/actions.ts